import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { Text, View } from 'react-native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function OptionsChip({ values, options, onSelect, }) {
    function handleSelect(value) {
        if (values === null || values === void 0 ? void 0 : values.includes(value)) {
            onSelect(values.filter(v => v !== value));
        }
        else {
            if (!values) {
                onSelect([value]);
            }
            else {
                onSelect([...values, value]);
            }
        }
    }
    return (_jsx(View, { style: {
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'flex-start',
            gap: 8,
        }, children: options.map((option, idx) => {
            const selected = values === null || values === void 0 ? void 0 : values.includes(option.value);
            return (_jsx(SccPressable, { elementName: "option_chip", disableLogging: true, style: {
                    borderRadius: 14,
                    borderWidth: 1.2,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 5,
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    borderColor: selected ? color.blue40 : color.gray20,
                    backgroundColor: selected ? color.brand5 : color.white,
                }, onPress: () => handleSelect(option.value), children: _jsx(Text, { style: {
                        textAlign: 'center',
                        fontSize: 16,
                        lineHeight: 24,
                        fontFamily: font.pretendardMedium,
                        color: selected ? color.brand50 : color.gray80,
                    }, children: option.label }) }, option.label + idx));
        }) }));
}
